import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { EventListenerService } from '../../services/close-listenenr.service';
import { reportingFilter } from '../../models/filter.model';
import { scheduling } from '../../models/scheduling.model';
import { SummaryComponent } from '../summary/summary.component';
import { ReportingService } from '../../services/reporting.service';

@Component({
  selector: 'app-scheduling',
  templateUrl: './scheduling.component.html',
  styleUrls: ['./scheduling.component.css']
})
export class SchedulingComponent implements OnInit {

  title: string = 'Scheduling';
  reportingType: string = '';
  reportType: string;
  reportName: string;
  selectedCols: any;
  currentFilters: Array<reportingFilter> = [];

  @ViewChild('summary', { read: ViewContainerRef })
  viewSummary: ViewContainerRef;
  scheduleFreq: string;
  schedule: scheduling;
 
  customReport: any = null;


  constructor(
    private commonService: CommonService
    , protected closeService: EventListenerService
    , private resolver: ComponentFactoryResolver
    , private reportingService: ReportingService
  ) { 
    this.closeService.close.subscribe(value => {
      if (value === 'summary') {
          this.viewSummary.clear();
      }
    });
  }

  ngOnInit() {
    var tempDate = new Date();
    this.schedule.startDate = this.commonService.getDateString(tempDate);
  }

  continue = () => 
  {
    if(this.viewSummary.length > 0)
    {
      this.viewSummary.clear;
    }

    var component = this.resolver.resolveComponentFactory(SummaryComponent);
    var summaryComponent = this.viewSummary.createComponent(component);
    (<SummaryComponent>summaryComponent.instance).reportType = this.reportType;
    (<SummaryComponent>summaryComponent.instance).reportName = this.reportName;
    (<SummaryComponent>summaryComponent.instance).selectedCols = this.selectedCols;
    (<SummaryComponent>summaryComponent.instance).currentFilters = this.currentFilters;
    (<SummaryComponent>summaryComponent.instance).schedule = this.schedule;
    (<SummaryComponent>summaryComponent.instance).customReport = this.customReport;
    (<SummaryComponent>summaryComponent.instance).reportingType = this.reportingType;

    $('.child-loader').animate({scrollLeft: 550 + 550 + 550}, 800);
  }

  updateEndDate() 
  {
    var tempDate = new Date();
    switch(this.schedule.frequency)
    {
      case 'WEEKLY':
        tempDate.setDate(tempDate.getDate() + 168);
        this.schedule.endDate = this.commonService.getDateString(tempDate);
        break;
      case 'MONTHLY':
        tempDate.setDate(tempDate.getDate() + 365);
        this.schedule.endDate = this.commonService.getDateString(tempDate);
        break;
    }
  }

  close = () => {
    this.closeService.closeEvent('scheduling');
  }


  //TESTING FUNCTIONS
  test = () => {
  
  }

  // #region common service variables
  get schedulingFreq ()
  {
     return this.reportingService.schedulingFreq; 
  }
  // #endregion

}

export class CustomReport {
  ReportID: number = -1;
  ReportName: string;
  LoginID: string;
  Columns: string [];
  Filters: string [] = [];
  // These 2 are strings as the are in JSON and will need to be converted
  FiltersJSON: string;
  SchedulingJSON: string;
  ReportType: string = '';
}


